// Localização: frontend/src/components/Management/AlertaList.js
//Este componente se concentra em exibir os alertas de forma clara e colorida.

import React from 'react';
import LoadingIndicator from '../Common/LoadingIndicator';
import { AlertTriangle, Package, Calendar, PackageCheck } from 'lucide-react';

const getAlertaColor = (tipo) => {
    switch (tipo) {
        case 'VENCIDO': return {
            bg: 'bg-red-100',
            text: 'text-red-800',
            border: 'border-l-4 border-red-500',
            icon: 'text-red-600'
        };
        case 'VALIDADE PRÓXIMA': return {
            bg: 'bg-yellow-100',
            text: 'text-yellow-800',
            border: 'border-l-4 border-yellow-500',
            icon: 'text-yellow-600'
        };
        case 'BAIXO ESTOQUE': return {
            bg: 'bg-orange-100',
            text: 'text-orange-800',
            border: 'border-l-4 border-orange-500',
            icon: 'text-orange-600'
        };
        case 'ESTOQUE ZERADO': return {
            bg: 'bg-red-100',
            text: 'text-red-800',
            border: 'border-l-4 border-red-500',
            icon: 'text-red-600'
        };
        default: return {
            bg: 'bg-gray-100',
            text: 'text-gray-800',
            border: '',
            icon: 'text-gray-600'
        };
    }
};

// Componente de Card para Mobile
const AlertaCard = ({ alerta }) => {
    const colors = getAlertaColor(alerta.tipo_alerta);
    
    return (
        <div className={`p-2 sm:p-4 rounded-lg shadow-md ${colors.bg} ${colors.text} ${colors.border}`}>
            <div className="flex items-start space-x-2 sm:space-x-3">
                <AlertTriangle className={`h-4 w-4 sm:h-5 sm:w-5 ${colors.icon} flex-shrink-0 mt-0.5`} />
                <div className="flex-1 min-w-0">
                    <p className="text-sm sm:text-lg font-bold">{alerta.tipo_alerta}</p>
                    <p className="text-xs sm:text-sm mt-1">
                        <span className="font-semibold">{alerta.nome_medicamento}</span> ({alerta.dosagem}{alerta.unidade_medida})
                    </p>
                </div>
            </div>
            
            <div className="mt-2 sm:mt-3 space-y-1 sm:space-y-2">
                <div className="flex items-center text-xs sm:text-sm">
                    <Package className={`h-3 w-3 sm:h-4 sm:w-4 mr-1.5 sm:mr-2 ${colors.icon} flex-shrink-0`} />
                    <span>
                        <span className="font-semibold">Lote:</span> <span className="font-medium">{alerta.lote}</span>
                    </span>
                </div>
                <div className="flex items-center text-xs sm:text-sm">
                    <PackageCheck className={`h-3 w-3 sm:h-4 sm:w-4 mr-1.5 sm:mr-2 ${colors.icon} flex-shrink-0`} />
                    <span>
                        <span className="font-semibold">Estoque:</span> <span className="font-medium">{alerta.quantidade_atual} {alerta.unidade_medida}</span>
                    </span>
                </div>
                <div className="flex items-center text-xs sm:text-sm">
                    <Calendar className={`h-3 w-3 sm:h-4 sm:w-4 mr-1.5 sm:mr-2 ${colors.icon} flex-shrink-0`} />
                    <span>
                        <span className="font-semibold">Validade:</span> <span className="font-medium">{new Date(alerta.data_validade).toLocaleDateString('pt-BR')}</span>
                        {alerta.dias_para_vencer < 0 && (
                            <span className="ml-1 sm:ml-2 text-xs">(Vencido há {Math.abs(alerta.dias_para_vencer)} dias)</span>
                        )}
                        {alerta.dias_para_vencer >= 0 && alerta.dias_para_vencer <= 90 && (
                            <span className="ml-1 sm:ml-2 text-xs">(Vence em {alerta.dias_para_vencer} dias)</span>
                        )}
                    </span>
                </div>
            </div>
        </div>
    );
};

const AlertaList = ({ data, isLoading }) => {
    return (
        <div className="mt-4">
            <h3 className="text-base sm:text-xl font-semibold text-gray-700 mb-4">Alertas de Validade e Estoque Crítico</h3>
            {isLoading ? (
                <LoadingIndicator />
            ) : data.length === 0 ? (
                <div className="p-4 sm:p-6 bg-green-100 text-green-800 rounded-lg text-center">
                    <p className="text-sm sm:text-base">
                        🎉 Não há alertas críticos de validade ou baixo estoque no momento!
                    </p>
                </div>
            ) : (
                <div className="grid grid-cols-2 md:grid-cols-2 gap-2 sm:gap-4">
                    {data.map((alerta) => (
                        <AlertaCard key={alerta.lote_id} alerta={alerta} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default AlertaList;